import { assert_array_not_empty, assert_not_null_return, assert_number_gte_0, assert_type_boolean, assert_type_number } from '@shared/asserts/utils_asserts';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { DTO__workspace_child_enity } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/dto_workspace_child_enity';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { ENUM__dto_class_name } from '../../serialization/ENUM__dto_class_name';
import { DTO__generation } from '../generation/DTO__generation';

export class DTO__user_task extends DTO__workspace_child_enity {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.USER_TASK;

  /*
   * FIELDS
   */

  //CLIENT RUNTIME FIELDS
  generations: DTO__generation[];

  last_generation_at: number;

  duration_adjusting!: number;

  are_generations_loaded: boolean;

  /*
   * METHODS
   */

  constructor() {
    super();

    this.generations = [];

    this.last_generation_at = CONSTANTS__shared.NUMBER_EMPTY_VALUE;

    this.are_generations_loaded = false;
  }

  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_type_number(this.last_generation_at);

    assert_number_gte_0(this.duration_adjusting);

    assert_type_boolean(this.are_generations_loaded);
  }

  getMostRecentGeneration(): DTO__generation {
    assert_array_not_empty(this.generations, { user_task_id: this._id, context: 'generations' });
    let generationsMutable = [...this.generations];

    let generationsMutableSorted = generationsMutable.sort(DTO__database_entity.sort_by_updated_at_newest_first);

    let out = assert_not_null_return(generationsMutableSorted[0], { id: this._id, context: 'generation' });

    return out;
  }
}
